import React, { useCallback, useMemo } from 'react';

import { getUsers } from '../actions/users';
import axios from 'axios';
import auth from '../utils/auth';

import { Link, useLocation, useParams } from 'react-router-dom';
import Loading from '../components/Loading.jsx';
import HomeNav from '../components/HomeNav';

import Fuse from 'fuse.js';

const searchOrders = async (term) => {
    let { data } = await axios.request({
        url: `/orders/search?order_number=${term}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID(),
            'Customer-Id': auth.getUserId(),
            Authorization: `Bearer ${auth.getToken()}`
        }
    });
    return data.data;
};

const Search = () => {
    const location = useLocation();
    const params = useParams();
    let orgFuse = React.useRef();
    const [inProgress, setInProgress] = React.useState(true);
    const [users, setUsers] = React.useState([]);
    const [orgs, setOrgs] = React.useState([]);
    const [orders, setOrders] = React.useState([]);
    const [results, setResults] = React.useState([]);

    const flatData = useMemo(() => [...orgs, ...users, ...orders], [orgs, users, orders]);

    const searchUsers = useCallback(async () => {
        let [users, orgs] = await getUsers();
        let orders = await searchOrders(params.term);

        setUsers(
            users.map((usr) => {
                usr.full_name = usr.name ? `${usr.name.given} ${usr.name.family}` : '';
                return usr;
            })
        );
        setOrgs(orgs.filter((org) => org.entity_id));
        setOrders(orders);
        setInProgress(false);
    }, [params.term]);

    React.useEffect(() => {
        setInProgress(true);
        searchUsers();
    }, [searchUsers]);

    React.useEffect(() => {
        if (flatData.length) {
            orgFuse.current = new Fuse(flatData, {
                keys: ['name.long', { name: 'entity_id', weight: 0.7 }, 'full_name', 'email', 'order_number'],
                threshold: 0.4,
                caseSensitive: true
            });
            setResults(orgFuse?.current?.search(params?.term || ''));
        }
    }, [flatData, params.term]);

    if (inProgress) {
        return <Loading />;
    }

    return (
        <>
            <HomeNav />
            <div className="container">
                <h2>Showing Results for "{params.term}"</h2>
                <div className="row">
                    <section className="col-xs-12">
                        <table className="table full-width">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Name/Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!results.length && (
                                    <tr>
                                        <td colSpan={2}>No Results found</td>
                                    </tr>
                                )}
                                {results.map(({ item }) => {
                                    if (item.name && item.name.long) {
                                        return (
                                            <tr key={item._id}>
                                                <td>
                                                    <strong>Org</strong>
                                                </td>
                                                <td>
                                                    <Link to={`/org/${item.entity_id}`}>{item.name.long}</Link>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (item.order_number) {
                                        return (
                                            <tr key={item.order_number}>
                                                <td>
                                                    <strong>Order</strong>
                                                </td>
                                                <td>
                                                    <Link to={`/orders/${item.order_number}`}>{item.order_number}</Link>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    return (
                                        <tr key={item._id}>
                                            <td>
                                                <strong>User</strong>
                                            </td>
                                            <td>
                                                <Link
                                                    to={`/customer/${item._id}`}
                                                    state={{
                                                        from: { pathname: location.pathname, title: 'Search Results' }
                                                    }}
                                                >
                                                    {item.full_name} ({item.email})
                                                </Link>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Search;
